var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadArrowpage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7533 68.4803H48.5683V50.569L56.5797 58.5804L59.2807 55.8604L46.6608 43.2405L34.0409 55.8604L36.7648 58.5575L44.7533 50.569V68.4803ZM26.121 80.8026C24.3636 80.8026 22.8974 80.2151 21.7224 79.0401C20.5474 77.8651 19.9586 76.3988 19.9561 74.6414V18.2945C19.9561 16.5396 20.5448 15.0746 21.7224 13.8996C22.8999 12.7246 24.3661 12.1358 26.121 12.1333H56.1982L73.3655 29.3006V74.6414C73.3655 76.3963 72.778 77.8625 71.603 79.0401C70.428 80.2176 68.9605 80.8051 67.2005 80.8026H26.121ZM54.2907 31.2081V15.9483H26.121C25.5335 15.9483 24.9943 16.1924 24.5035 16.6807C24.0126 17.169 23.7685 17.707 23.771 18.2945V74.6414C23.771 75.2264 24.0152 75.7643 24.5035 76.2551C24.9918 76.746 25.5297 76.9902 26.1172 76.9876H67.2043C67.7893 76.9876 68.3272 76.7435 68.8181 76.2551C69.3089 75.7668 69.5531 75.2277 69.5505 74.6376V31.2081H54.2907Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadArrowpage);
export default __webpack_public_path__ + "static/media/icon-upload-arrowpage.85504a84dd333097914c4351daaa64ee.svg";
export { ForwardRef as ReactComponent };